import { WidgetsPricingMain } from '@/widgets/pricing';

export const PagesPricingMain = () => <WidgetsPricingMain />;
